<script>
  import {sd} from '@/da';
  import MenuItemView from '../components/MenuItemView.svelte';
  import {promotions$} from '../../stream';

  function handlePromotionsClickFuc(item) {
    return function () {
      sd.track('web_click', {$screen_name: 'home', $element_content: 'navigation_promotions_' + item});
    };
  }
</script>

<style>
  .wrap {
    box-sizing: border-box;
    padding: 16px;
    width: 328px;
    background: rgba(26, 29, 31, 0.96);
    backdrop-filter: blur(10px);
    cursor: default;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
  .circle {
    margin-top: 4px;
    border: 3px solid var(--blue);
    border-radius: 50%;
    width: 4px;
    height: 4px;
    background: #fff;
  }
  .sub-menu-title-icon {
    max-height: 18px;
    vertical-align: middle;
  }
</style>

{#if $promotions$.length > 0}
  <div class="wrap df fdc T2 ovh">
    {#each $promotions$ as item}
      <MenuItemView theme="dark" link={item.link} target="_self" title={item.title} subTitle={item.subTitle} noArrow on:click={handlePromotionsClickFuc(item.title)}>
<!--        <div slot="circle-suffix" class="circle" />-->
        <div slot="title-suffix" class="ml10" style="width: 54px;">
          {#if item.cornerIcon}
            <img class="sub-menu-title-icon" alt="promotion" src={item.fullCornerIcon} />
          {/if}
        </div>
      </MenuItemView>
    {/each}
  </div>
{/if}
